import { render, staticRenderFns } from "./RealStates.vue?vue&type=template&id=c45eff42"
import script from "./RealStates.vue?vue&type=script&lang=js"
export * from "./RealStates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports